import React from "react";
import type { Column, GridApi, IRowNode } from "ag-grid-community";

/**
 * 커스텀 cellRenderer 컬럼용 찾기(Ctrl+F) 헬퍼
 */

interface FindRendererParams {
  api?: GridApi;
  node?: IRowNode;
  column?: Column;
}

/** 찾기 매칭용 텍스트 = 화면 표시값. 표시값이 없으면 셀에 실제로 보이는 원래 값(code)을 쓴다. */
export const toFindText = (
  displayValue: unknown,
  fallback: unknown
): string => {
  const display = displayValue == null ? "" : String(displayValue);
  if (display) return display;
  return fallback == null ? "" : String(fallback);
};

/**
 * 표시 텍스트에 찾기 하이라이트를 입혀 반환한다. (React 렌더러 반환값으로 사용)
 * 검색 중이 아니거나 매치가 없으면 문자열 그대로, 매치가 있으면 해당 구간만
 */
export const renderFindHighlight = (
  params: FindRendererParams,
  displayValue: unknown
): React.ReactNode => {
  const text = displayValue == null ? "" : String(displayValue);
  const { api, node, column } = params;
  if (!api || !node || !column || api.isDestroyed()) return text;
  if (!api.getGridOption("findSearchValue")) return text;

  const parts = api.findGetParts({ node, column, value: text });
  if (!parts.some((p) => p.match)) return text;

  return (
    <>
      {parts.map((p, i) =>
        p.match ? (
          <span
            key={i}
            className={p.activeMatch ? "ag-find-active-match" : "ag-find-match"}
          >
            {p.value}
          </span>
        ) : (
          <React.Fragment key={i}>{p.value}</React.Fragment>
        )
      )}
    </>
  );
};
